document.addEventListener('DOMContentLoaded', () => {
    const scenarioInputs = document.querySelectorAll('.scenario-input input');
    scenarioInputs.forEach(input => {
        input.addEventListener('change', (e) => {
            // AJAX-Request an den Server, oder
            // UI-Update in der Tabelle TODO kann weg?
            // console.log(`Neuer Wert für ${input.name}: ${input.value}`);
        });
    });
});
